/* eslint-disable no-console */
import { normalizeError, LEVELS, LogEvent, LogContext } from '@zencity/microfrontend-utils';
import { datadogLogs } from '@datadog/browser-logs';
import { datadogRum } from '@datadog/browser-rum';
import { describeNetworkError } from './describeNetworkError';

const isServer = typeof window === 'undefined';

export const LogNetworkError = (error: unknown) => {
  const description = describeNetworkError(error);
  if (isServer) {
    console.warn(`Network error ${JSON.stringify(description)}`);
  } else {
    datadogLogs.logger.warn('Network error', { error: description });
  }
};

export const LogError = (message: LogEvent['message'], errorObj?: LogEvent['error'], context?: LogContext) => {
  const normalizedError = normalizeError(message, errorObj);
  if (isServer) {
    const errorMessage = `Error ${JSON.stringify(normalizedError)}`;
    console.error(errorMessage);
  } else {
    datadogLogs.logger.error(message, { context, errorObj });
    datadogRum.addError(normalizedError, context);
  }
};

export const LogWarning = (message: LogEvent['message'], context?: LogContext) => {
  if (isServer) {
    console.warn(message, context ?? '');
  } else {
    datadogLogs.logger.warn(message, { context });
    datadogRum.addAction(LEVELS.WARN, {
      message,
      ...context,
    });
  }
};

export const LogInfo = (message: LogEvent['message'], context?: LogContext) => {
  if (isServer) {
    console.info(message);
  } else {
    datadogLogs.logger.info(message, { context });
    datadogRum.addAction(LEVELS.INFO, {
      message,
      ...context,
    });
  }
};

export const LogDebug = (message: LogEvent['message'], context?: LogContext) => {
  if (isServer) {
    console.debug(message);
  } else {
    datadogLogs.logger.debug(message, { context });
    datadogRum.addAction(LEVELS.DEBUG, {
      message,
      ...context,
    });
  }
};
